import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { advertisementsQuery } from "../services/queries";

// All of the Organization's ads (drafts and expired included); callers filter
// for what they need. The "active" key suffix keeps this apart from AdCenter's
// ["advertisements", schoolId], which also fetches cancelled ads — sharing a
// key let either page briefly render the other's list.
export const useAdvertisements = ({ enabled }: { enabled: boolean }) => {
  const { user, token } = useAuth();

  return useQuery({
    ...advertisementsQuery(user?.schoolId, token),
    enabled: !!token && !!user?.schoolId && enabled,
  });
};
